import { requestsClient } from "./apollo";

export const initUploadMutation = async () => {
  try {
    const { initUploadSession } = await requestsClient.initUploadSession();
    return initUploadSession;
  } catch (e) {
    console.log(e);
    throw new Error('Upload failed');
  }
};